export default __webpack_public_path__ + "static/media/max_contact.1e9895fd.jpeg";